<template lang="pug">
  .main-container
    div(v-if="solicitacoesRetificacao.length > 0").margin-bottom
      el-card.green-alert-card
        span.fal.fa-info-circle
        span.alert-font {{ `Você possui ${solicitacoesRetificacao.length > 1 ? 'solicitações de Retificação para os editais' : 'uma solicitação de Retificação para o edital'} ${editaisSolicitacao.join(', ')}.` }}
    div
      el-card(v-loading='carregando')
        el-row(:gutter="20")
          el-col(:span="24")
            span.title Minhas solicitações
          el-table.table(
            :data='listaSolicitacoes'
            :default-sort="{ prop: 'edital.numero', order: 'descending' }"
          )
            template(slot='empty') Não foram encontradas solicitações com os dados informados
            el-table-column(
              label='Situação',
              header-align='center',
              align='center',
              sortable,
              prop='situacao'
            )
              template(slot-scope='scope')
                el-tooltip(:content='renderTooltip(scope.row.situacao)')
                  i(:class='renderSituacao(scope.row.situacao)')
            el-table-column(
              label='Nº do edital'
              header-align='left',
              align='left'
              sortable
              prop='edital.numero'
            )
            el-table-column(
              label='Data da solicitação'
              header-align='left',
              align='left'
              sortable
              prop='dataCadastro'
            )
              template(slot-scope='scope')
                span {{ dateFromTimestamp(scope.row.dataCadastro) }}
            el-table-column(
              label='Tipo de solicitação'
              header-align='left',
              sortable
              prop='edital.tipoEdital'
            )
            el-table-column(
              label='Ações',
              header-align='center',
              align='center'
            )
              template(slot-scope='scope')
                el-dropdown(trigger='click')
                    el-button(type='primary' size='medium') Ações
                      i.marginLeft(class='fas fa-chevron-down')
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(@click.native='abrirSolicitacao(scope.row)')
                            i(class='fa fa-eye')
                              span.textDropdown Visualizar
                        el-dropdown-item(v-if="scope.row.situacao === 'RETIFICADO' && scope.row.isPossivelResponder",
                          @click.native='editarSolicitacao(scope.row)')
                            i(class='fa fa-sync-alt')
                              span.textDropdown Retificar

    Pagination(:total='quantidadeResultados' :pagina='paginaAtual' :tamanhoPagina='tamanhoPagina' @changePage='changePage')

    modal-visualizar-solicitacao(
      v-if='showModalSolicitacao'
      :modalOpen='showModalSolicitacao'
      :solicitacao='solicitacaoVisualizar'
      @close-modal='showModalSolicitacao = false'
    )
</template>

<script>
import { Pagination } from 'sicarf-components'
import situacoes from '@/constants/situacoes'
import {
  findByCurrentUser,
  findSituacaoRetificadoByCurrentUser,
} from '@/services/solicitacaoCredenciadoService'
import ModalVisualizarSolicitacao from '@/components/modalVisualizarEdital.vue'

export default {
  components: {
    Pagination,
    ModalVisualizarSolicitacao,
  },
  data() {
    return {
      listaSolicitacoes: [],
      filtro: {},
      filtroSort: {
        ordem: 'edital.numero',
        ordemDirecao: 'DESC',
      },
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
      carregando: false,
      showModalSolicitacao: false,
      solicitacaoVisualizar: {},
      solicitacoesRetificacao: null,
    }
  },
  mounted() {
    this.buscarSolicitacoes()
    this.buscarSolicitacoesRetificacao()
  },

  methods: {
    async buscarSolicitacoes() {
      this.carregando = true
      const result = await findByCurrentUser()
      this.listaSolicitacoes = result.content
      this.carregando = false
    },

    async buscarSolicitacoesRetificacao() {
      const response = await findSituacaoRetificadoByCurrentUser()
      const editais = []

      this.solicitacoesRetificacao = response

      response.forEach((value) => {
        editais.push(value.edital.numero)
      })

      this.editaisSolicitacao = editais
    },

    changePage(page) {
      this.paginaAtual = page - 1
      this.buscarSolicitacoes()
    },

    renderSituacao(situacao) {
      switch (situacao) {
        case situacoes.RETIFICADO:
          return 'fas fa-exclamation'
        case situacoes.AGUARDANDO_APROVACAO:
        case situacoes.AGUARDANDO_VALIDACAO:
          return 'fas fa-history'
        case situacoes.REPROVADO:
          return 'fas fa-times redColor'
        case situacoes.APROVADO:
          return 'fas fa-check greenColor'
        default:
          return ''
      }
    },

    renderTooltip(situacao) {
      switch (situacao) {
        case situacoes.RETIFICADO:
          return 'Aguardando retificação'
        case situacoes.AGUARDANDO_APROVACAO:
          return 'Aguardando análise'
        case situacoes.REPROVADO:
          return 'Solicitação reprovada'
        case situacoes.APROVADO:
          return 'Solicitação aprovada'
        case situacoes.AGUARDANDO_VALIDACAO:
          return 'Aguardando validação'
        default:
          return ''
      }
    },

    sort(item) {
      this.filtroSort.ordem = item.prop
      if (item.order === 'ascending') {
        this.filtroSort.ordemDirecao = 'ASC'
      } else {
        this.filtroSort.ordemDirecao = 'DESC'
      }
      this.buscarSolicitacoes(this.paginaAtual)
    },

    abrirSolicitacao(s) {
      this.solicitacaoVisualizar = s
      this.showModalSolicitacao = true
    },

    editarSolicitacao(s) {
      this.$router.push({
        name: 'credenciado/editar',
        params: {
          solicitacao: s,
          idEdital: s.edital.id,
        },
      })
    },

    dateFromTimestamp(timestamp) {
      const date = new Date(timestamp)

      const day = '0' + date.getUTCDate()
      const month = '0' + (date.getUTCMonth() + 1)
      const year = date.getUTCFullYear()

      return `${day.substr(-2)}/${month.substr(-2)}/${year}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.title {
  font-size: 20px;
  text-align: left;
  color: #606266;
}

.table {
  padding-top: 30px;
}

.el-card {
  border-radius: 20px;
  padding: 12px;
}

.textDropdown {
  margin-left: 5px;
}

.redColor {
  color: $error;
}

.greenColor {
  color: $color-primary;
}

.marginLeft {
  margin-left: 5px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.green-alert-card {
  border-color: $color-primary;
  border-width: 2px;

  .alert-font {
    font-size: $font-size-medium;
    color: $color-primary;
  }

  .fal {
    color: $color-primary;
    font-size: 20px;
    margin-right: 10px;
  }
}
</style>
